import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    constructor(public loadingController: LoadingController) {}
    private loading: any;
    private isLoading: boolean = false;
    private holdLoading: boolean = false;

    async showLoader(message?: string) {
        this.loading = await this.loadingController.create({
            message: message ?? 'Loading',
            cssClass: 'custom-loader',
            spinner: 'bubbles',
            mode: 'ios',
            backdropDismiss: false,
        });

        return this.loading.present().then(() => {
            this.isLoading = true;
        });
    }

    async hideLoader() {
        if (!this.holdLoading) {
            await this.loading
            ?.dismiss()
            .then(() => {
                this.isLoading = false;
            })
            .catch((error) => {
                console.log('error', error);
            });   
        }
    }

    getIsLoading() {
        return this.isLoading;
    }

    setHolderLoading(isHold: boolean) {
        this.holdLoading = isHold
    }

    getIsHolding() {
        return this.holdLoading
    }
}
